(function() {
    'use strict';

    angular
        .module('consulatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('vote', {
            parent: 'app',
            url: '/vote/:userPhone/:zone',
            data: {
                authorities: ['ROLE_VOTE','ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/vote/vote.html',
                    controller: 'VoteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();